import { ArrowRight, CircleDotDashed } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components/ui/Button'
import { PageHeader } from '../../components/ui/PageHeader'
import { StatusLabel } from '../../components/ui/StatusLabel'
import { KNOWLEDGE_MODULES } from '../../data/dashboardData'

export function LearningMapPage() {
  const navigate = useNavigate()
  const [selectedId, setSelectedId] = useState(KNOWLEDGE_MODULES[0]?.id ?? '')
  const selectedModule = KNOWLEDGE_MODULES.find((item) => item.id === selectedId)

  return (
    <div className="content-page">
      <PageHeader
        title="数学学习地图"
        description="用知识前置关系和真实作答证据，决定下一步学习顺序。"
        action={
          <Button onClick={() => navigate('/tutor')}>开始入学诊断</Button>
        }
      />

      <div className="map-layout">
        <section className="map-list" aria-label="知识模块列表">
          {KNOWLEDGE_MODULES.map((module, index) => (
            <button
              key={module.id}
              type="button"
              className={`map-list__item ${
                selectedId === module.id ? 'map-list__item--active' : ''
              }`}
              onClick={() => setSelectedId(module.id)}
            >
              <span className="map-list__index">{String(index + 1).padStart(2, '0')}</span>
              <span className="map-list__copy">
                <strong>{module.name}</strong>
                <span>{module.description}</span>
              </span>
              <StatusLabel status={module.status} />
            </button>
          ))}
        </section>

        <aside className="map-detail" aria-live="polite">
          <CircleDotDashed size={30} strokeWidth={1.5} aria-hidden="true" />
          <h2>{selectedModule?.name ?? '请选择知识模块'}</h2>
          <p>{selectedModule?.description}</p>
          <dl>
            <div>
              <dt>当前状态</dt>
              <dd>{selectedModule?.status}</dd>
            </div>
            <div>
              <dt>下一步</dt>
              <dd>{selectedModule?.action}</dd>
            </div>
            <div>
              <dt>掌握证据</dt>
              <dd>尚未形成</dd>
            </div>
          </dl>
          <button type="button" onClick={() => navigate('/tutor')}>
            进入诊断
            <ArrowRight size={17} aria-hidden="true" />
          </button>
        </aside>
      </div>
    </div>
  )
}
